import { IMAGES } from "../constants/config";

export const entreprisesContent = {
  meta: {
    title: "Crush Emploi — Recrutez la Gen Z en vidéo",
    description:
      "Candidatures vidéo pour évaluer soft skills et motivation avant l'entretien. Processus raccourci, forfaits flexibles — alternative économique au recrutement classique.",
  },
  variant: "entreprise",
  alternateLink: {
    label: "Espace candidat",
    to: "/candidats",
  },
  hero: {
    title: "Recrutez la Gen Z avec des candidatures vidéo",
    subtitle:
      "Évaluez motivation, communication et soft skills avant le premier entretien.",
    cta: "Pré-inscription entreprise",
    image: IMAGES.heroes.entreprise,
    imageAlt: "Équipe de recruteurs collaborant autour de données et candidatures",
  },
  why: {
    title: "Le recrutement n'a pas suivi la Gen Z",
    stats: [
      {
        value: "21,1 %",
        label: "de chômage chez les 15–24 ans en France (T1 2026)",
        source: "Insee",
        sourceUrl: "https://www.insee.fr/fr/statistiques/8989990",
      },
      {
        value: "95 %",
        label: "des 16–24 ans utilisent les réseaux sociaux (2025)",
        source: "Insee",
        sourceUrl: "https://www.statistiques.com/internet/adolescents-et-internet",
      },
    ],
    paragraphs: [
      "Les jeunes de 16 à 25 ans vivent sur les réseaux sociaux, pas sur les jobboards. Les annonces traditionnelles peinent à susciter leur intérêt.",
    ],
    itemsTitle: "Pourquoi Crush Emploi ?",
    items: [
      {
        icon: "time",
        title: "Processus plus court",
        description:
          "Likez les candidatures en quelques secondes, identifiez rapidement les profils pertinents et obtenez un crush mutuel pour un contact direct.",
      },
      {
        icon: "mobile",
        title: "Canal adapté à la Gen Z",
        description:
          "Une app mobile pensée pour les habitudes des 16–26 ans, là où ils passent déjà leur temps.",
      },
      {
        icon: "videocam",
        title: "Candidatures vidéo authentiques",
        description:
          "Découvrez la personnalité et l'aisance à l'oral de chaque candidat avant de planifier un entretien.",
      },
    ],
  },
  howItWorks: {
    title: "Comment ça marche ?",
    image: IMAGES.sections.hommeRecruiter,
    imageAlt: "Recruteur travaillant sur ordinateur",
    steps: [
      {
        title: "Créez votre profil entreprise",
        description:
          "SIRET vérifié, secteur, ville, logo et vidéo de présentation optionnelle.",
      },
      {
        title: "Publiez vos offres",
        description:
          "CDI, CDD, stage, alternance, saisonnier — offres textuelles détaillées.",
      },
      {
        title: "Likez et recrutez",
        description:
          "Recevez des candidatures vidéo, likez les profils et obtenez un crush mutuel pour un contact direct.",
      },
    ],
  },
  economic: {
    title: "Une alternative économique au recrutement classique",
    highlight: "3 000 € – 10 000 €",
    source: "Eurécia",
    sourceUrl: "https://www.eurecia.com/blog/cout-recrutement-optimisation/",
    paragraphs: [
      "En France, le budget recrutement moyen varie entre 3 000 € et 10 000 € par poste. Une erreur de casting peut doubler, voire tripler, ces coûts.",
      "Crush Emploi se positionne comme une solution compétitive : forfaits flexibles, processus accéléré et identification rapide des profils — pour recruter autrement, sans sacrifier la qualité.",
    ],
  },
  pricing: {
    title: "Nos offres",
  },
  faq: {
    title: "Questions fréquentes",
    items: [
      {
        question: "C'est pour qui ?",
        answer:
          "PME, startups et entreprises avec un SIRET français souhaitant recruter des jeunes de 16 à 26 ans.",
      },
      {
        question: "Combien ça coûte ?",
        answer:
          "Les candidats sont gratuits. Les entreprises souscrivent un abonnement pour publier des offres — une alternative bien plus accessible qu'un recrutement classique. Contactez-nous pour connaître les tarifs.",
      },
      {
        question: "Comment fonctionne le crush ?",
        answer:
          "Un candidat postule en vidéo à une offre. Si vous likez sa candidature en retour, c'est un crush mutuel : ses coordonnées vous sont transmises pour le recontacter directement.",
      },
      {
        question: "Le SIRET est-il obligatoire ?",
        answer:
          "Oui, il est vérifié à l'inscription pour garantir l'authenticité des entreprises sur la plateforme.",
      },
      {
        question: "Les offres sont-elles en vidéo ?",
        answer:
          "Non, pour l'instant : vos offres sont textuelles et seules les candidatures des jeunes sont en vidéo. Des offres en vidéo sont envisagées en V2.",
      },
      {
        question: "Puis-je avoir une vidéo de présentation ?",
        answer:
          "Oui, une vidéo de présentation entreprise optionnelle peut compléter votre profil pour renforcer votre visibilité.",
      },
    ],
  },
  ctaBanner: {
    title: "Prêt à recruter autrement ?",
    subtitle:
      "Rejoignez les entreprises qui révolutionnent leur recrutement. Un conseiller vous recontactera pour organiser votre démo.",
  },
};
